import { Moment } from 'moment';
import { FIELDS_TYPES } from 'src/api/config/type.config';
import { LookupFields, UrlFields, UserFields } from 'src/modules/modules.type';
import { LookUpRecord, UserRecord } from 'src/types/main';

export const actionsVPO = 'VPOActions';
export const columnVPOListName = 'ColumnVPO';
export const columnBlockVPOListName = 'VPOColumnBlock';
export const subdivisionVPOListName = 'VPOsubdivision';
export const processVPOListName = 'VPOprocess';
export const demandVPOListName = 'VPODemand';
export const VPOInconsistences = 'VPOInconsistencies';
// export const planListActionsListName = 'MyTaskActions';
export const VPOdependenciesList = 'VPOdependencies';
export const VPOgroupList = 'VPOgroup';
export const VPOfactoryList = 'VPOfactory';
export const VPOsettingsListName = 'VPOSettings';
export const VPOcontactsListName = 'VPOContacts';
export const VPOinstructionsFilesLibName = 'VPOInstructions';
export const VPOReportPeriodList = 'VPOReportPeriod';
export const VPOStatusReportList = 'VPOStatusQuestionnaire';
export const VPOReportRegionList = 'ReportRegion';

export const myVPOActionListNameFields = {
  [actionsVPO]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Column: FIELDS_TYPES.LOOKUP,
    ColumnBlock: FIELDS_TYPES.LOOKUP,
    Subdivision: FIELDS_TYPES.LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
    Demand: FIELDS_TYPES.LOOKUP,
    DemandVPOColumns: FIELDS_TYPES.LOOKUP,
    ColumnTitle: FIELDS_TYPES.STRING,
    ColumnID: FIELDS_TYPES.STRING,
    ColumnBlockTitle: FIELDS_TYPES.STRING,
    ColumnBlockID: FIELDS_TYPES.STRING,
    GroupID: FIELDS_TYPES.STRING,
    Inconsistencies: FIELDS_TYPES.MULTI_STRING,
    Created: FIELDS_TYPES.DATE,
    FactoryID: FIELDS_TYPES.STRING,
    GroupTitle: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
  },
  [columnVPOListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
  },
  [columnBlockVPOListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
  },
  [subdivisionVPOListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    VPOgroup: FIELDS_TYPES.MULTI_LOOKUP,
    TypeSubdivision: FIELDS_TYPES.LOOKUP
  },
  [processVPOListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    BlockContent: FIELDS_TYPES.STRING,
    BlockContentTitle: FIELDS_TYPES.STRING,
  },
  [demandVPOListName]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
  },
  // [planListActionsListName]: {
  //   ID: FIELDS_TYPES.ID,
  //   Title: FIELDS_TYPES.STRING,
  //   Description: FIELDS_TYPES.STRING,
  //   Meeting: FIELDS_TYPES.LOOKUP,
  //   DateForDone: FIELDS_TYPES.DATE,
  //   Created: FIELDS_TYPES.DATE,
  //   Status: FIELDS_TYPES.LOOKUP,
  //   Status_x003a_Color: FIELDS_TYPES.LOOKUP,
  //   Responsible: FIELDS_TYPES.USER,
  //   AuthorEmail: FIELDS_TYPES.STRING,
  //   ResponsibleEmail: FIELDS_TYPES.STRING,
  //   Editor: FIELDS_TYPES.USER,
  // },
  [VPOInconsistences]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Inconsistences: FIELDS_TYPES.MULTI_STRING,
    IdVPOactions: FIELDS_TYPES.NUMBER,
  },
  [VPOdependenciesList]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Group: FIELDS_TYPES.LOOKUP,
    Factory: FIELDS_TYPES.LOOKUP,
    Column: FIELDS_TYPES.LOOKUP,
    Subdivision: FIELDS_TYPES.LOOKUP,
  },
  [VPOgroupList]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
  },
  [VPOfactoryList]: {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Code: FIELDS_TYPES.STRING,
    VPOgroup: FIELDS_TYPES.MULTI_LOOKUP,
  },
  [VPOsettingsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Description: FIELDS_TYPES.STRING,
    PathUrl: FIELDS_TYPES.LINK,
    IconUrl: FIELDS_TYPES.LINK,
    UsersGroup: FIELDS_TYPES.MULTI_USER,
  },
  [VPOcontactsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Phone: FIELDS_TYPES.STRING,
    Email: FIELDS_TYPES.STRING,
  },
  [VPOinstructionsFilesLibName]: {
    ID: FIELDS_TYPES.ID,
    CardID: FIELDS_TYPES.NUMBER,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
    VersionDocument: FIELDS_TYPES.BOOLEAN,
  },
  [VPOReportPeriodList]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.LOOKUP,
    Group: FIELDS_TYPES.LOOKUP,
  },
  [VPOStatusReportList]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ColumnID: FIELDS_TYPES.STRING,
    ColumnTitle: FIELDS_TYPES.STRING,
    GroupID: FIELDS_TYPES.STRING,
    GroupTitle: FIELDS_TYPES.STRING,
    FactoryID: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_ID: FIELDS_TYPES.LOOKUP,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    CountYes: FIELDS_TYPES.STRING,
    CountQuestions: FIELDS_TYPES.STRING,
    CountNull: FIELDS_TYPES.STRING,
  },
  [VPOReportRegionList]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    ColumnID: FIELDS_TYPES.STRING,
    ColumnTitle: FIELDS_TYPES.STRING,
    GroupID: FIELDS_TYPES.STRING,
    GroupTitle: FIELDS_TYPES.STRING,
    FactoryID: FIELDS_TYPES.STRING,
    FactoryTitle: FIELDS_TYPES.STRING,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    SubdivisionID: FIELDS_TYPES.STRING,
    SubdivisionTitle: FIELDS_TYPES.STRING,
    CountYes: FIELDS_TYPES.STRING,
    CountQuestions: FIELDS_TYPES.STRING,
    CountNull: FIELDS_TYPES.STRING,
  }
};

export type myVPOActionListNameFieldsRecordType = {
  [actionsVPO]: {
    ID: number;
    Title: string;
    Column: LookupFields;
    ColumnBlock: LookupFields;
    Subdivision: LookupFields;
    Process: LookupFields;
    Demand: LookupFields;
    DemandVPOColumns: LookupFields;
    ColumnTitle: string;
    ColumnID: string;
    ColumnBlockTitle: string;
    ColumnBlockID: string;
    GroupID: string;
    Inconsistencies: string;
    Created: Date;
  };
  [columnVPOListName]: {
    Title: string;
    ID: number;
    Code: string;
  };
  [columnBlockVPOListName]: {
    Title: string;
    ID: number;
  };
  [subdivisionVPOListName]: {
    Title: string;
    ID: number;
    VPOgroup: LookupFields[];
    TypeSubdivision: LookUpRecord
  };
  [processVPOListName]: {
    Title: string;
    ID: number;
    BlockContent: string;
    BlockContentTitle: string;
  };
  [demandVPOListName]: {
    Title: string;
    ID: number;
  };
  // [planListActionsListName]: {
  //   ID: number;
  //   Title: string;
  //   Description: string;
  //   Meeting: LookupFields;
  //   DateForDone: Date;
  //   Created: Date;
  //   Status: LookupFields;
  //   Status_x003a_Color: LookupFields;
  //   Responsible: UserFields;
  //   AuthorEmail: string;
  //   ResponsibleEmail: string;
  //   Editor: UserFields;
  // };
  [VPOInconsistences]: {
    ID: number;
    Title: string;
    Inconsistences: string;
    IdVPOactions: number;
  };
  [VPOdependenciesList]: {
    ID: number;
    Title: string;
    Group: LookupFields;
    Factory: LookupFields;
    Column: LookupFields;
    Subdivision: LookupFields;
  };
  [VPOgroupList]: {
    Title: string;
    ID: number;
  };
  [VPOfactoryList]: {
    Title: string;
    ID: number;
    Code: string;
    VPOgroup: LookupFields[];
  };
  [VPOsettingsListName]: {
    ID: number;
    Title: string;
    Description: string;
    PathUrl: UrlFields;
    IconUrl: UrlFields;
    UsersGroup: UserFields[];
  };
  [VPOcontactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [VPOinstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [VPOReportPeriodList]: {
    ID: number;
    Title: string;
    Factory: LookupFields;
    Group: LookupFields;
  };
  [VPOStatusReportList]: {
    ID: number;
    Title: string;
    ColumnID: string;
    ColumnTitle: string;
    GroupID: string;
    GroupTitle: string;
    FactoryID: string;
    FactoryTitle: string;
    Status: LookupFields;
    Status_x003a_ID: LookupFields;
    Month: string;
    Year: string;
    CountYes: string;
    CountQuestions: string;
    CountNull: string;
  },
  [VPOReportRegionList]: {
    ID: number;
    Title: string;
    ColumnID: string;
    ColumnTitle: string;
    GroupID: string;
    GroupTitle: string;
    FactoryID: string;
    FactoryTitle: string;
    Month: string;
    Year: string;
    SubdivisionID: string;
    SubdivisionTitle: string;
    CountYes: string;
    CountQuestions: string;
    CountNull: string;
  }
};

export type myVPOActionListNameFieldsType = {
  [actionsVPO]: {
    ID: number;
    Title: string;
    Column: LookUpRecord;
    ColumnBlock: LookUpRecord;
    Subdivision: LookUpRecord;
    Process: LookUpRecord;
    Demand: LookUpRecord;
    DemandVPOColumns: LookUpRecord;
    ColumnTitle: string;
    ColumnID: string;
    ColumnBlockTitle: string;
    ColumnBlockID: string;
    GroupID: string;
    Inconsistencies: string;
    Created: Moment;
  };
  [columnVPOListName]: {
    Title: string;
    ID: number;
    Code: string;
  };
  [columnBlockVPOListName]: {
    Title: string;
    ID: number;
  };
  [subdivisionVPOListName]: {
    Title: string;
    ID: number;
    VPOgroup: LookUpRecord[];
    TypeSubdivision: LookUpRecord;
  };
  [processVPOListName]: {
    Title: string;
    ID: number;
    BlockContent: string;
    BlockContentTitle: string;
  };
  [demandVPOListName]: {
    Title: string;
    ID: number;
  };
  // [planListActionsListName]: {
  //   ID: number;
  //   Title: string;
  //   Description: string;
  //   Meeting: LookUpRecord;
  //   DateForDone: Moment;
  //   Created: Moment;
  //   Status: LookUpRecord;
  //   Status_x003a_Color: LookUpRecord;
  //   Responsible: UserRecord;
  //   AuthorEmail: string;
  //   ResponsibleEmail: string;
  //   Editor: UserRecord;
  // };
  [VPOInconsistences]: {
    ID: number;
    Title: string;
    Inconsistences: string;
    IdVPOactions: number;
  };
  [VPOdependenciesList]: {
    ID: number;
    Title: string;
    Group: LookUpRecord;
    Factory: LookUpRecord;
    Column: LookUpRecord;
    Subdivision: LookUpRecord;
  };
  [VPOgroupList]: {
    Title: string;
    ID: number;
  };
  [VPOfactoryList]: {
    Title: string;
    ID: number;
    Code: string;
    VPOgroup: LookUpRecord[];
  };
  [VPOsettingsListName]: {
    ID: number;
    Title: string;
    Description: string;
    PathUrl: string;
    IconUrl: string;
    UsersGroup: UserFields[];
  };
  [VPOcontactsListName]: {
    ID: number;
    Title: string;
    Phone: string;
    Email: string;
  };
  [VPOinstructionsFilesLibName]: {
    ID: number;
    CardID: number;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
    VersionDocument: boolean;
  };
  [VPOReportPeriodList]: {
    ID: number;
    Title: string;
    Factory: LookUpRecord;
    Group: LookUpRecord;
  };
  [VPOStatusReportList]: {
    ID: number;
    Title: string;
    ColumnID: string;
    ColumnTitle: string;
    GroupID: string;
    GroupTitle: string;
    FactoryID: string;
    FactoryTitle: string;
    Status: LookUpRecord;
    Status_x003a_ID: LookUpRecord;
    Month: string;
    Year: string;
    CountYes: string;
    CountQuestions: string;
    CountNull: string;
  },
  [VPOReportRegionList]: {
    ID: number;
    Title: string;
    ColumnID: string;
    ColumnTitle: string;
    GroupID: string;
    GroupTitle: string;
    FactoryID: string;
    FactoryTitle: string;
    Month: string;
    Year: string;
    SubdivisionID: string;
    SubdivisionTitle: string;
    CountYes: string;
    CountQuestions: string;
    CountNull: string;
  }
};
